import { z } from 'zod';
import { CustomVizRequest } from 'libs/end-to-end/src/custom-viz/CustomVizRequest';
import { CustomVizProgressStep } from 'libs/end-to-end/src/custom-viz/CustomVizProgressStep';

export const UserAnalysisDetails = z.object({
  customVizRequest: CustomVizRequest,
});

export type UserAnalysisDetails = z.infer<typeof UserAnalysisDetails>;

export const UserAnalysisInformationStatus = z.enum([
  'pending',
  'succeeded',
  'failed',
  'not-enough-data',
]);

export type UserAnalysisInformationStatus = z.infer<
  typeof UserAnalysisInformationStatus
>;

export const UserAnalysisInformation = z.object({
  id: z.string(),
  customVizRequest: CustomVizRequest,
  status: UserAnalysisInformationStatus,
  startedAtEpoch: z.number(),
  estimatedTimeRemaningInSeconds: z.number().nullable(),
  shareLink: z.string(),
  currentStep: CustomVizProgressStep.nullable(),
});

export type UserAnalysisInformation = z.infer<typeof UserAnalysisInformation>;

export const UserAnalysisInformations = z.array(UserAnalysisInformation);

export type UserAnalysisInformations = z.infer<typeof UserAnalysisInformations>;
